/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-shadow */
/* eslint-disable prefer-const */
import { Button, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { ApiActions } from '@orientaction/api-actions';
import { getFromLS, isAdmin, publicIconPath } from '@orientaction/utils';
import { find, kebabCase } from 'lodash';
import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import round from 'lodash/round';
import sumBy from 'lodash/sumBy';
import { FC, useEffect, useMemo, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Details from './Details';
import Diagram from './Diagram';
import ResultImage from './ResultImage';
import ShareIcons from './ShareIcons';
import style from './style';

interface IProps {
  userResponse: any;
  variables: any;
  typeTest?: any;
  newVersion?: boolean;
  sendDataMax?: (data: any) => void;
}

const getColorByIndex = (index: number) => {
  if (index === 1) {
    return '#FDCE29';
  }
  if (index === 2) {
    return '#F7A82E';
  }
  if (index === 3) {
    return '#ED6637';
  }
  if (index === 4) {
    return '#C93646';
  }
  if (index === 5) {
    return '#942A59';
  }
  if (index === 6) {
    return '#662169';
  }
};

const HorizontalDiagramContainer: FC<IProps> = ({
  userResponse,
  variables,
  typeTest,
  newVersion = false,
  sendDataMax,
}) => {
  const [linkCopied, setLinkCopied] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const classes = style();

  // Helper function to strip HTML tags
  const stripHtml = (html: string) => {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html || '';
    return tmp.textContent || tmp.innerText || '';
  };
  /*  const variableGroup = groupBy(userResponse?.attributes.responses.data, (response: any) => {
    return response.attributes.variable.data.id;
  }); */

  /*  const dataMapValue = map(variableGroup, (response: any) => {
    const sumVariable = sumBy(response, (variable: any) => variable.attributes.variableValue);
    return {
      value: sumVariable,
      label: response[0]?.attributes?.variable?.data?.attributes?.name,
      title: response[0]?.attributes?.variable?.data?.attributes?.title,
      image: response[0]?.attributes?.variable?.data?.attributes?.image,
      description: response[0]?.attributes?.variable?.data?.attributes?.description,
      variableId: response[0]?.attributes?.variable?.data?.id,
    };
  }); */

  /* const totalValue = sumBy(dataMapValue, (value: any) => value.value) || 0;
  const userVariablesIds = (dataMapValue || []).map((d: any) => d.variableId);
  const allVariablesIds = variables.map((v: any) => v.id);
  const missingVariablesIds = allVariablesIds.filter((vId: any) => !userVariablesIds.includes(vId));
  const missingVariables = variables.filter((v: any) => missingVariablesIds.includes(v.id));
  const toConcat = missingVariables.map((mV: any) => {
    return {
      value: 0,
      label: mV?.attributes?.name,
      title: mV?.attributes?.title,
      description: mV?.attributes?.description,
      image: '',
      color: '#fff',
    };
  });
  const dataMapValuePourcentage = map(
    dataMapValue.sort((a: any, b: any) => b.value - a.value),
    (value: any, index: number) => {
      const valuePercent = (value.value * 100) / totalValue;
      const valueLabel = value.label;
      return {
        value: round(valuePercent),
        label: valueLabel,
        title: value?.title,
        description: value?.description,
        image: value?.image,
        color: getColorByIndex(index + 1),
      };
    },
  ).concat(toConcat); */

  let allVariables: any[] = [];
  userResponse?.attributes?.responses?.data.forEach((response: any) => {
    response?.attributes.variable.data.forEach((variable: any) => {
      allVariables.push({
        ...variable,
        variableValue: response.attributes.variableValue,
      });
    });
  });

  const variableGroup = groupBy(allVariables, (variable: any) => variable.id);

  const sumScore = userResponse?.attributes?.responses?.data.reduce(
    (accumulator: any, resp: any) => {
      return accumulator + resp.attributes.variableValue;
    },
    0
  );

  const variableToShow = find(variables, (variable: any) => {
    return (
      variable?.attributes?.minInterval <= sumScore && sumScore <= variable?.attributes?.maxInterval
    );
  });

  const dataMapValue = map(variableGroup, (variables: any[]) => {
    const sumVariable = sumBy(variables, (variable: any) => variable.variableValue);
    const firstVariable = variables[0];
    return {
      value: sumVariable,
      label: stripHtml(firstVariable.attributes.title),
      title: firstVariable.attributes.title,
      image: firstVariable.attributes.image,
      description: firstVariable.attributes.description,
      variableId: firstVariable.id,
      codeColor: firstVariable.attributes.codeColor,
      textRestitutionChart: firstVariable.attributes.textRestitutionChart,
      video: firstVariable.attributes.video,
      typeMedia: firstVariable.attributes.typeMedia,
    };
  });

  const totalValue = sumBy(dataMapValue, (item: any) => item.value) || 0;

  const userVariablesIds = dataMapValue.map((d: any) => d.variableId);
  const allVariablesIds = variables.map((v: any) => v.id);
  const missingVariablesIds = allVariablesIds.filter((vId: any) => !userVariablesIds.includes(vId));
  const missingVariables = variables.filter((v: any) => missingVariablesIds.includes(v.id));

  const toConcat = missingVariables.map((mV: any) => {
    return {
      value: 0,
      label: stripHtml(mV.attributes.title),
      title: mV.attributes.title,
      description: mV.attributes.description,
      image: '',
      color: '#fff',
    };
  });

  const dataMapValuePourcentage = useMemo(
    () =>
      dataMapValue
        .sort((a: any, b: any) => b.value - a.value)
        .map((item: any, index: number) => {
          const valuePercent = (item.value * 100) / totalValue;
          return {
            ...item,
            value: round(valuePercent, 2),
            // color: getColorByIndex(index + 1),
          };
        })
        .concat(toConcat),
    [dataMapValue, totalValue, toConcat]
  );

  const dataMapValueConcat = useMemo(
    () =>
      dataMapValue
        .sort((a: any, b: any) => b.value - a.value)
        .map((item: any, index: number) => {
          return {
            ...item,
            color: item?.codeColor,
          };
        })
        .concat(toConcat),
    [dataMapValue, toConcat]
  );

  const maximumResponse = useMemo(() => dataMapValuePourcentage[0], [dataMapValuePourcentage]);

  const goToTestPage = () => {
    dispatch(ApiActions.setTabLayout(1 as any));
    history.push('/user/tests');
  };

  const copyTestLink = () => {
    navigator.clipboard.writeText(testUrl);
    setLinkCopied(true);
  };

  const test = userResponse?.attributes?.test?.data;
  const testUrl = `${process.env.REACT_APP_SHARE_ENDPOINT}/api/test/${test.id}/${kebabCase(
    test.attributes.resultTitle || test.attributes.title
  )}`;
  const user = JSON.parse(getFromLS('userInfos') || '');

  useEffect(() => {
    if (sendDataMax) {
      if (typeTest === 4 && variableToShow) {
        // Pour les tests de type "seuils et intervalles", utiliser la variable correspondant au score
        sendDataMax({
          title: variableToShow.attributes.title,
          image: variableToShow.attributes.image,
          video: variableToShow.attributes.video,
          description: variableToShow.attributes.description,
          label: variableToShow.attributes.name,
          typeMedia: variableToShow.attributes.typeMedia,
        });
      } else {
        // Pour les autres types de tests, utiliser la réponse maximum
        sendDataMax(maximumResponse);
      }
    }
  }, [typeTest, variableToShow, maximumResponse, sendDataMax, sumScore]);

  return (
    <>
      {!newVersion && (
        <>
          <div className={classes.resultTextParagraph}>
            {ReactHtmlParser(
              typeTest === 4 ? variableToShow?.attributes?.title : maximumResponse.title
            )}
          </div>

          <Paper className={classes.resultPaperContainer} elevation={0}>
            <Grid
              alignItems="center"
              justifyContent="center"
              className={classes.diagramContainer}
              container={true}>
              {typeTest !== 4 && (
                <Grid
                  className={classes.diagramContent}
                  item={true}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}>
                  {dataMapValuePourcentage && (
                    <Diagram
                      data={typeTest === 5 ? dataMapValueConcat : dataMapValuePourcentage}
                      typeTest={typeTest}
                    />
                  )}
                </Grid>
              )}
            </Grid>
          </Paper>
        </>
      )}
      {newVersion && (
        <div className={classes.diagramContainerNew}>
          {dataMapValuePourcentage && (
            <Diagram
              data={typeTest === 5 ? dataMapValueConcat : dataMapValuePourcentage}
              typeTest={typeTest}
            />
          )}
        </div>
      )}
    </>
  );
};

export default HorizontalDiagramContainer;
